import { render, staticRenderFns } from "./ProductText.vue?vue&type=template&id=0d4e8c97&functional=true&"
import script from "./ProductText.vue?vue&type=script&lang=js&"
export * from "./ProductText.vue?vue&type=script&lang=js&"
import style0 from "./ProductText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports